

const DeliveryReducer = (state, action) => {
    switch (action.type) {
        case "GET_DELIVERIES_START":
            return {
                ...state,
                deliveries: [],
                isFetching: true,
                error: false,
            };
        case "GET_DELIVERIES_SUCCESS":
            return {
                ...state,
                deliveries: action.payload.deliveries,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_DELIVERIES_FAILURE":
            return {
                ...state,
                deliveries: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_DELIVERY_START":
            return {
                ...state,
                delivery: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_DELIVERY_SUCCESS":
            return {
                ...state,
                delivery: action.payload.delivery,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_DELIVERY_FAILURE":
            return {
                ...state,
                delivery: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_DELIVERY_START":
            return {
                ...state,
                delivery: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_DELIVERY_SUCCESS":
            return {
                ...state,
                delivery: action.payload.delivery,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_DELIVERY_FAILURE":
            return {
                ...state,
                delivery: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "ACTIVATE_DELIVERY_START":
            return {
                ...state,
                delivery: {},
                isFetchingActivate: true,
                errorActivate: false,
            };
        case "ACTIVATE_DELIVERY_SUCCESS":
            return {
                ...state,
                delivery: action.payload.delivery,
                isFetchingActivate: false,
                errorActivate: false,
            };
        case "ACTIVATE_DELIVERY_FAILURE":
            return {
                ...state,
                delivery: {},
                isFetchingActivate: false,
                errorActivate: action.payload,
            };
        case "GET_TRANSPORTEURS_SUCCESS":
            return {
                ...state,
                transporteurs: action.payload.transporteurs,
            }
        case "GET_LIVREURS_SUCCESS":
            return {
                ...state,
                livreurs: action.payload.livreurs,
            }
        default:
            return { ...state };
    }
}

export default DeliveryReducer;